import { z } from "zod";

export const schema = z.object({
  licenseAmount: z.string(),
  subscription: z.string().min(1, "Du må velge et abonnement."),
});

export type SubscriptionSchema = z.infer<typeof schema>;
